import { QueryClient } from '@tanstack/react-query';
import { DEFAULT_QUERY_OPTIONS } from '@monorepo/rest-client';

// Mặc định dùng chung cho mọi query REST của app: không retry 4xx, không gọi lại ngầm.
// Lý do nằm ở libs/rest-client/src/lib/queryDefaults.js (API public giới hạn 20 request/60s).
export const queryClient = new QueryClient({ defaultOptions: { queries: DEFAULT_QUERY_OPTIONS } });
